const gameTemplateList =[
    {buttonName: "Try a Game Set For Success", buttonText: "easyGame", 
        desc: "The salary, net income and starting cash make this game easy.  This " +
            "might be a good choice for players who have been struggling to find a " +
            "way to successflly play the game."
    },
    {buttonName: "Try a Game That Is Somewhat Challenging", buttonText: "midGame",
        desc: "This game can still be somewhat challenging if players do not review and change " +
            "some of the basic game choices (job, home, car)."
    },
    {buttonName: "Try a Game That is More Challenging", buttonText: "difficultGame",
        desc: "In order to play this game successfully, players must review and change " +
            "most of the basic game choices (job, home, car)."
    },
    {buttonName: "Try a Game That is Almost Impossible", buttonText: "veryDifficultGame",
        desc: "In order to be successful in this game, players will need to review and " +
            "revise basic game choices (job, home, car).  They will also need to earn badges " +
            "and complete some of the extra credit challenges. "
    },
    {buttonName: "Play a Game With Unlocked Features Enabled", buttonText: "unlockedFeaturesEnabled",
        desc: "This is an option that fast-tracks the game so that players are eligible to " +
            "enable all of the 'unlocked Features'.  This feature is not recommended for " +
            "regular gameplay, however, it can be useful when trying to give players experience " +
            "with some of the more advanced concepts 401(k) savings and investing."
    },
    {buttonName: "Restore a Game You Played Previously", buttonText: "restorePreviousGame",
        desc: "This feature is mostly intended for situations where a player ended their game " +
            "early in order to complete a specific lesson/task.  Once they have completed that " +
            "task, they can end the 'task-specific' game and then restore the game that they " +
            "were playing previously."
    }
]
export default gameTemplateList;